import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    DeleteMoneyPageAction as DeleteMoneyPageActionMutation,
    DeleteMoneyPageActionVariables,
    UrlAutomationDeleteInput,
} from 'nutshell-graphql-types';

import DELETE_MONEY_PAGE_ACTION from '../mutations/delete-money-page-action.graphql';

export const useDeleteMoneyPageAction = (): {
    deleteMoneyPageAction: (input: UrlAutomationDeleteInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [deleteMoneyPageAction, {loading, error}] = useMutation<
        DeleteMoneyPageActionMutation,
        DeleteMoneyPageActionVariables
    >(DELETE_MONEY_PAGE_ACTION);

    return {
        deleteMoneyPageAction: (input: UrlAutomationDeleteInput) =>
            deleteMoneyPageAction({variables: {input}}),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
